import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ComplaintFormComponent } from '../complaint-form/complaint-form.component';
import { MatDialog } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { GrievanceCommentComponent } from '../grievance-comment/grievance-comment.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-complaint',
  templateUrl: './complaint.component.html',
  styleUrls: ['./complaint.component.scss']
})
export class ComplaintComponent implements OnInit ,AfterViewInit{
  complaintList: any;
  commentList: any;
  constructor(private dialog: MatDialog,public umsService: UmsService,public router: Router,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
  ) { }
  // convertUTCToIST(dateString: string): string {
  //   const utcDate = new Date(dateString); // Convert string to Date object
  //   const istDate = new Date(utcDate.getTime() - (330 * 60 * 1000)); // IST is UTC + 5:30
  //   return this.datePipe.transform(istDate, 'dd/MM/yyyy h:mm:ss a', 'Asia/Kolkata') || '';
  // }
  ngOnInit(): void {
    this.getComplaintData();
    // this.getCommentData();
  }
  ngAfterViewInit(): void {
    this.getComplaintData();
  }


  addnewrecord() {
    const dialogRef = this.dialog.open(ComplaintFormComponent, {
      width: '700px',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getComplaintData();
    });
  }

  getComplaintData() {
    this.spinner.show();
    const payload = {};
    payload['StuloginID'] = sessionStorage.getItem('loginId');
    payload['UserID'] = sessionStorage.getItem('StudentPersonalId')
    this.umsService.getComplaint(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.complaintList = res.data;
      } 
    },

  );
  }


  addnewrecord1() {
    const dialogRef = this.dialog.open(GrievanceCommentComponent, {
      width: '700px',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getComplaintData();
    });
  }

  redirect(to): void {
    this.router.navigate([to]);
  }
  details(data: any) {
    localStorage.setItem('grivenceData', JSON.stringify(data));
    this.router.navigate(['grievance-comment-form'],
       { state: { data } });
  }

  convertUTCToIST(dateString: string): string {
    const utcDate = new Date(dateString); // Convert string to Date object
    // Directly use the date pipe with 'Asia/Kolkata' time zone
    return this.datePipe.transform(utcDate, 'dd/MM/yyyy h:mm:ss a', 'Asia/Kolkata') || '';
  }
}
